import React from 'react';
import { Box, Grid, CardContent, Card, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import './seccionPreview.scss';

export default function SeccionPreviewDelegacion({ regiones, delegaciones, delegacionesSeleccionadas, delegacionOrigen }) {
    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <>
            <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                <CardContent className='card-container'>
                    <strong>
                        Delegaciones
                    </strong>

                    <Grid container spacing={0.5}>
 <Grid size={{ xs: 6, md: 4, lg: 4 }}>
                            <ItemR>
                                Delegación de Origen: <strong>{delegaciones?.filter((d) => d.idDelegacion === delegacionOrigen)[0]?.descripcion}</strong>
                            </ItemR>
                        </Grid>
                    </Grid>

                    <Grid container columns={{ xs: 1, lg: 3 }} spacing={2.5}>
                        {regiones.map((reg) => {
                            let listarRegion = false;
                            const regDeleg = delegaciones.filter((deleg) => deleg.idRegion === reg.idRegion);
                            let listaDelegaciones = [];

                            regDeleg.map((deleg) => {
                                if (delegacionesSeleccionadas.filter((d) => d === deleg.idDelegacion).length > 0) {
                                    listarRegion = true;
                                    listaDelegaciones.push(deleg);
                                }
                            })

                            if (listarRegion) {
                                return (
 <Grid size={{ xs: 1 }}>
                                        <Card elevation={0} className='card-container-border'>
                                            <CardContent>
                                                <div className='seccion-title'>{reg.descripcion}</div>
                                                <div container spacing={0.5} className='seccion-container'>
                                                    {
                                                        listaDelegaciones.map((deleg, index) => {
                                                            return <Chip key={index} label={deleg.descripcion} className="chip-preview" />
                                                        })
                                                    }
                                                </div>
                                                <br />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            }
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </>
    )

};